var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.source)?_c('img',{staticClass:"banner banner-static",attrs:{"src":_vm.source,"width":_vm.resource.width()}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }